import React, { Component } from 'react';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import { Link } from 'react-router-dom';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import LocationActionCreators from 'actions/LocationActionCreators';
import Roles from 'constants/UserRoles';
import LocationStore from 'stores/LocationStore';
import SessionStore from 'stores/SessionStore';
import ToastStore from 'stores/ToastStore';
import { getMarkets } from 'utils/MarketAPIUtils';
import { updateLocation } from 'utils/LocationWebAPIUtils';
import Container from 'components/v2/container';
import Card from 'components/v2/card';
import DeleteButton from 'components/v2/buttons/DeleteButton';
import EditButton from 'components/v2/buttons/EditButton';
import PlusIcon from 'components/v2/icons/PlusIcon';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import { withTranslation } from 'react-i18next';
import CargomaticSelect from '../../v2/select';
const CAN_UPDATE = [Roles.LOCATIONS_MANAGER, Roles.LOCATIONS_ADMIN, Roles.GOD];
function mapRoles() {
    const roles = SessionStore.getUserRoles();
    const canUpdate = roles.some((r) => CAN_UPDATE.includes(r));
    return { canUpdate };
}
const LocationMap = withGoogleMap(({ lat, lng }) => (React.createElement(GoogleMap, { defaultCenter: { lat, lng }, defaultZoom: 8, showMarker: true, visible: true },
    React.createElement(Marker, { position: { lat, lng } }))));
class Details extends Component {
    constructor(props) {
        super(props);
        this.handleMarketChange = (market) => {
            this.setState({ market: market.code });
        };
        this.handleSaveMarket = async () => {
            const { t } = this.props;
            const market = this.state.markets.find((m) => m.code === this.state.market);
            if (!market) {
                return;
            }
            try {
                const location = this.getRequest();
                await updateLocation(location);
                this.showNotifications(t('MARKET_UPDATE_SUCCESS'), 'success');
                this.setState({ location });
            }
            catch (e) {
                this.showNotifications(e.message, 'error');
            }
            finally {
                this.setState({ editing: false });
            }
        };
        this.handleToggleEditMarket = () => {
            const { location } = this.state;
            this.setState((prevState) => {
                const editing = !prevState.editing;
                const market = editing ? location.market.code : '';
                return {
                    editing,
                    market,
                };
            });
        };
        this.handleAliasChange = (e) => {
            const { target: { value: alias }, } = e;
            this.setState({
                alias,
            });
        };
        this.handleAddAlias = (e) => {
            e.preventDefault();
            const { location } = this.state;
            if (this.state.alias.length === 0) {
                return;
            }
            LocationActionCreators.addLocationAlias(location.id, this.state.alias);
            this.setState({ alias: '' });
        };
        this.handleConfirmDelete = () => {
            LocationActionCreators.removeLocation(this.state.currentLocationId);
            this.handleHideConfirmModal();
        };
        this.handleDelete = (currentLocationId) => {
            this.setState({
                currentLocationId,
                showConfirmModal: true,
            });
        };
        this.handleHideConfirmModal = () => {
            this.setState({
                showConfirmModal: false,
            });
        };
        this.state = {
            alias: '',
            position: {},
            showConfirmModal: false,
            currentLocationId: null,
            editing: false,
            market: '',
            markets: [],
            canUpdate: false,
            location: null,
        };
    }
    async fetchMarkets() {
        const { entity: { markets }, } = await getMarkets();
        this.setState({ markets });
    }
    getStateFromStore() {
        const location = LocationStore.getLocation();
        const updates = {
            location,
        };
        if (location && location.market) {
            updates.market = location.market.code;
        }
        this.setState(updates);
    }
    componentDidMount() {
        LocationStore.addChangeListener(() => this.getStateFromStore());
        this.fetchMarkets();
        this.setRoles();
    }
    componentWillUnmount() {
        LocationActionCreators.clearLocation();
    }
    setRoles() {
        this.setState(Object.assign({}, mapRoles()));
    }
    showNotifications(title, level) {
        ToastStore.getNotifications().push({
            title,
            body: '',
            level,
        });
        ToastStore.emitChange();
    }
    getRequest() {
        const market = this.state.markets.find((m) => m.code === this.state.market);
        return Object.assign(Object.assign({}, this.state.location), { market });
    }
    deleteAlias(location, alias) {
        LocationActionCreators.deleteLocationAlias(location._id, alias);
    }
    render() {
        const { t } = this.props;
        if (!this.state.location) {
            return null;
        }
        const location = _.extend(this.state.location, this.state.position);
        const { aliases } = location;
        return (React.createElement(Container, { className: "py-10" },
            React.createElement("div", { className: "grid grid-cols-1 sm:grid-cols-6 gap-8" },
                React.createElement("div", { className: "lg:col-span-2" },
                    React.createElement(Link, { to: "/locations", className: "text-sm mb-4 underline block" },
                        React.createElement("span", null, t('BACK_TO_LOCATIONS'))),
                    React.createElement(Card, { header: () => (React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("h3", { className: "my-0 truncate" }, location.name || t('DETAILS')),
                            this.state.canUpdate && (React.createElement(DeleteButton, { onClick: () => this.handleDelete(location._id) })))), grayFooter: true, footer: () => (React.createElement("div", null,
                            React.createElement("h3", { className: "text-lg font-medium leading-6 my-0" }, t('ALIASES')),
                            this.state.canUpdate && (React.createElement("form", { className: "mt-4", action: "#", onSubmit: this.handleAddAlias },
                                React.createElement("div", { className: "flex justify-end" },
                                    React.createElement("input", { placeholder: t('ENTER_NEW_ALIAS'), className: "flex-1 block form-field rounded-r-none", type: "text", name: "alias", value: this.state.alias, onChange: this.handleAliasChange }),
                                    React.createElement("button", { type: "submit", disabled: this.state.alias.length === 0, title: t('ADD_ALIAS'), className: "button button-green rounded-l-none" },
                                        React.createElement("div", { className: "flex items-center justify-center" },
                                            React.createElement(PlusIcon, null)))))),
                            React.createElement("ul", { className: "mt-4 divide-y divide-gray-200 bg-white rounded-md shadow" }, aliases.map((alias, i) => (React.createElement("li", { className: "px-4 py-4 flex items-center justify-between", key: i },
                                React.createElement("span", { className: "text-sm" }, alias),
                                this.state.canUpdate && (React.createElement(DeleteButton, { size: "small", onClick: () => this.deleteAlias(location, alias) })))))))) },
                        React.createElement("dl", { className: "grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2" },
                            React.createElement(DescriptionListItem, { className: "sm:col-span-full", label: t('ADDRESS') },
                                React.createElement("div", { className: "text-sm truncate" }, location.address)),
                            React.createElement(DescriptionListItem, { classname: "sm:col-span-1", label: t('TYPE') },
                                React.createElement("div", { className: "text-sm" }, location._sub_type)),
                            React.createElement(DescriptionListItem, { classname: "sm:col-span-1", label: t('LONG_LAT') },
                                React.createElement("div", { className: "text-sm" },
                                    location.lng,
                                    ", ",
                                    location.lat)),
                            React.createElement(DescriptionListItem, { className: "sm:col-span-full", label: titleize(t('MARKET', { count: 1 })) },
                                !this.state.editing && (React.createElement("div", { className: "flex items-center space-x-2" },
                                    React.createElement("span", null, location.market.code),
                                    this.state.canUpdate && (React.createElement(EditButton, { size: "small", onClick: this.handleToggleEditMarket })))),
                                this.state.editing && (React.createElement("div", { className: "flex flex-wrap -mx-2" },
                                    React.createElement(CargomaticSelect, { className: "px-2", hideLabel: true, onSelect: this.handleMarketChange, items: this.state.markets, selected: this.state.market, valueKey: "code", textKey: "name" }),
                                    React.createElement("div", { className: "px-2 flex space-x-1" },
                                        React.createElement("button", { className: "button button-green", onClick: this.handleSaveMarket }, titleize(t('SAVE'))),
                                        React.createElement("button", { className: "button button-gray", onClick: this.handleToggleEditMarket }, titleize(t('CANCEL')))))))))),
                React.createElement("div", { className: "lg:col-span-2" },
                    React.createElement(LocationMap, { googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places", loadingElement: React.createElement("div", { style: { height: `100%` } }), containerElement: React.createElement("div", { style: { height: '100%' } }), mapElement: React.createElement("div", { style: { height: `100%` } }), lat: location.lat, lng: location.lng }))),
            React.createElement(ConfirmModal, { show: this.state.showConfirmModal, title: t('DELETE_CONFIRMATION'), message: t('DELETE_LOCATION_CONFIRMATION'), onConfirm: this.handleConfirmDelete, onHide: this.handleHideConfirmModal })));
    }
}
export default withTranslation()(Details);
